import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SkillBarProps from '../../model/skill-bar-props';

export default function SkillBar(props: SkillBarProps){
    return(
        <Box className="main-icon" display='flex' justifyContent='center' flexDirection='column' alignItems='center' paddingLeft={6} paddingRight={6} paddingBottom={8}>
            <Typography 
                        component='span' 
                        variant='h6' 
                        color='#fff' 
                        fontWeight='regular' 
                        textAlign='center'
            >
                {props.title}
            </Typography>

            {props.icon}
            
            <Box>
                <Box position='absolute' width={props.progress} height={8} borderRadius={25} sx={{ background: props.color }}>  </Box>
                <Box width={116} height={8} borderRadius={25} sx={{ background:'#121214'}}></Box>
                
            </Box>
        </Box>
    )
}